import { Image } from "@chakra-ui/react";
import { IndexableType } from "dexie";
import { useEffect, useState } from "react";
import { AudioFile, db, getActiveAudioFile } from "../db";

interface WaveformImageProps {
  studentId: number;
  phrase: string;
}

const WaveformImage = ({ studentId, phrase }: WaveformImageProps) => {
  const [src, setSrc] = useState<string>();
  const [audioFileId, setAudioFileId] = useState<string>();

  useEffect(() => {
    const getAudioFileImg = async (studentId: number, phrase: string) => {
      const file = await getActiveAudioFile(studentId, phrase);
      if (file) {
        setSrc(file.waveformImg);
        setAudioFileId(file.id);
      }
    };
    getAudioFileImg(studentId, phrase);

    const updateListener = (
      modifications: Object,
      primaryKey: IndexableType
    ) => {
      if (
        primaryKey === audioFileId &&
        modifications.hasOwnProperty("waveformImg")
      ) {
        setSrc((modifications as AudioFile).waveformImg);
      }
    };

    db.audioFiles.hook("updating", updateListener);

    return () => {
      db.audioFiles.hook("updating").unsubscribe(updateListener);
    };
  }, [audioFileId, phrase, studentId]);

  if (src) {
    return <Image height="30px" width="100%" src={src} bgColor="#EDF2F7" />;
  }
  return null;
};

export default WaveformImage;
